import { CheckCircle, Clear, RadioButtonUnchecked } from '@mui/icons-material'
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Tooltip,
} from '@mui/material'
import { useState } from 'react'
import { CircularProgress } from '@mui/material'
import { Participant } from '../providers/workouts'

type Props = {
  participant: Participant
  editPermission: boolean
  onRemoveParticipant: (id: string) => Promise<void>
  onToggleCheckIn: (participant: Participant) => Promise<void>
}

const ParticipantsListItem = ({
  editPermission,
  participant,
  onRemoveParticipant,
  onToggleCheckIn,
}: Props) => {
  const [loading, setLoading] = useState(false)
  const [checkInLoading, setCheckInLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleCancel = () => {
    setOpen(false)
  }

  const handleProceed = async () => {
    setLoading(true)
    setOpen(false)
    try {
      await onRemoveParticipant(participant.uid)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const handleToggleCheckIn = async () => {
    setCheckInLoading(true)
    try {
      await onToggleCheckIn(participant)
    } catch (error) {
      console.log(error)
    } finally {
      setCheckInLoading(false)
    }
  }

  return (
    <ListItem sx={{ paddingX: 0 }}>
      <>
        <ListItemText
          primary={participant.displayName}
          secondary={
            editPermission
              ? participant.checkedIn
                ? `Incheckad${participant.phone || participant.email ? ` · ${participant.phone || participant.email}` : ''}`
                : participant.phone || participant.email
              : participant.checkedIn
              ? 'Incheckad'
              : undefined
          }
        />
        {editPermission && (
          <ListItemSecondaryAction>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Tooltip
                title={
                  participant.checkedIn
                    ? 'Ångra incheckning'
                    : 'Checka in deltagare'
                }
              >
                <IconButton onClick={handleToggleCheckIn}>
                  {checkInLoading ? (
                    <CircularProgress size={25} />
                  ) : participant.checkedIn ? (
                    <CheckCircle color="success" />
                  ) : (
                    <RadioButtonUnchecked />
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title="Avboka deltagare">
                <IconButton onClick={handleOpen}>
                  {loading ? (
                    <CircularProgress size={25} />
                  ) : (
                    <Clear color="error" />
                  )}
                </IconButton>
              </Tooltip>
            </Box>
          </ListItemSecondaryAction>
        )}
      </>
      <Dialog
        open={open}
        keepMounted
        onClose={handleCancel}
        onBackdropClick={handleCancel}
        aria-describedby="alert-dialog-cancel-participant"
      >
        <DialogTitle>{'Avboka deltagare'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-cancel-participant">
            Vill du verkligen avboka {participant.displayName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Avbryt</Button>
          <Button color="error" onClick={handleProceed}>
            Avboka
          </Button>
        </DialogActions>
      </Dialog>
    </ListItem>
  )
}

export default ParticipantsListItem
